// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__t6aBy","textarea":"styles_textarea__2p6ru"};